import dayjs from 'dayjs';
import { DotationApi } from '../../api/Dotation';
import { DotationEsag, QuotaComplet } from '../../api/Dotation/types';
import { DotationsState } from './Droits.types';

interface SessionData {
  identifiantAgent: string;
  identifiantEntite: string;
}

export class DroitsActions {
  /**
   * Récupère toutes les dotations pour un agent
   */
  static async fetchAllDotations(session: SessionData, silent?: boolean): Promise<DotationsState> {
    const dateRef = `${dayjs().year()}0101`;

    try {
      const [cpData, rttData, hsData] = await Promise.all([
        // Dotations ESAG format
        DotationApi.loadConges(`?dateAcquisition=${dateRef}&identifiantAgent=${session.identifiantAgent}&identifiantEntite=${session.identifiantEntite}&complet=1`, silent).catch(() => null),
        DotationApi.loadQuotas(`?dateAcquisition=${dateRef}&identifiantAgent=${session.identifiantAgent}&identifiantEntite=${session.identifiantEntite}&withNatureAbsence=1&natureAbsenceCode=RTT&complet=1`, silent).catch(() => null),
        DotationApi.loadQuotas(`?dateAcquisition=${dateRef}&identifiantAgent=${session.identifiantAgent}&identifiantEntite=${session.identifiantEntite}&withNatureAbsence=1&natureAbsenceCode=HR&complet=1`, silent).catch(() => null),
      ]);

      // Transformation des données API vers nos types
      const CP = this.setDefaultDotationEsag(cpData);
      const RTT = this.setDefaultDotationEsag(rttData);
      const HS = this.setDefaultDotationEsag(hsData);

      const dotations: DotationsState = {
        CP,
        RTT,
        HS,
      };

      return dotations;

    } catch (error) {
      console.error('[DroitsActions] Error fetching dotations:', error);
      throw new Error('Impossible de récupérer les dotations');
    }
  }

  /**
   * Transforme une DotationEsag de l'API vers notre type
   */
  private static setDefaultDotationEsag(data: DotationEsag | null): DotationEsag | null {
    if (!data) return null;

    return {
      ...data,
      droit: data?.droit || '0',
      pris_a_valider: data?.pris_a_valider || '0',
      pris_a_venir: data?.pris_a_venir || '0',
      reste: data?.reste || '0',
      complet: this.setDefaultDotationComplete(data.complet || {} as QuotaComplet),
    };
  }

  private static setDefaultDotationComplete(data: QuotaComplet): QuotaComplet {
    return {
      ...data,
      droitReliquat: data.droitReliquat || '0',
      droitEnCours: data.droitEnCours || undefined,
      droitHorsPeriode: data.droitHorsPeriode || undefined,
      droitAnciennete: data.droitAnciennete || undefined,
      droitTotal: data.droitTotal || '0',
      droitN1: data.droitN1 || '0',
      prisReliquat: data.prisReliquat || '0',
      prisEnCours: data.prisEnCours || '0',
      prisTotal: data.prisTotal || '0',
      prisN1: data.prisN1 || '0',
      CETReliquat: data.CETReliquat || undefined,
      CETEnCours: data.CETEnCours || undefined,
      CETTotal: data.CETTotal || undefined,
      resteReliquat: data.resteReliquat || '0',
      resteEnCours: data.resteEnCours || undefined,
      resteTotal: data.resteTotal || '0',
      resteN1: data.resteN1 || '0',
    };
  }
}
